// extracted by mini-css-extract-plugin
module.exports = {"pagination":"totalPagination_pagination__kVQNJ","arrow_icon":"totalPagination_arrow_icon__PsG6f"};